import WarningAlertComponent from '../../WarningAlert.component';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChildAlertProps } from '../../BaseAlert.component';

const ExternalLinkDeleteAlertComponent = ({
  handleConfirm,
}: ChildAlertProps) => {
  const { t } = useTranslation();

  return (
    <WarningAlertComponent onClose={handleConfirm}>
      {t('External link will be removed')}.
      <br />
      {t('Continue')}?
    </WarningAlertComponent>
  );
};

export default ExternalLinkDeleteAlertComponent;
